module.exports = __webpack_public_path__ + "img/SES_280288860.6415889f.jpg";